import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Route, Switch, HashRouter } from "react-router-dom";
import App from "./App";
import Operaciones from "./components/Operaciones";
import Administracion from "./components/Administracion";
import Separacion from "./components/Separacion";
import AdministracionCausas from "./components/Operaciones/AdministracionCausas";
import BusquedaCausas from "./components/Operaciones/BusquedaCausas";
import Moneda from "./components/Administracion/Moneda";
import Activo from "./components/Administracion/Activo";
import Contacto from "./components/Administracion/Contacto";
import Etapa from "./components/Administracion/Etapa";
import OrigenDatos from "./components/Administracion/OrigenDatos";
import Pais from "./components/Administracion/Pais";
import Usuarios from "./components/Administracion/Usuarios";
import Relaciones from "./components/Administracion/Relaciones";
import PersonaEmpresa from "./components/Administracion/PersonaEmpresa";
import TipoProceso from "./components/Administracion/TipoProceso";
import Titulos from "./components/Administracion/Titulos";
import Tribunal from "./components/Administracion/Tribunal";
import DireccionUnidad from "./components/Administracion/DireccionUnidad";
import DireccionType from "./components/Administracion/DireccionType";
import Perfiles from "./components/Administracion/Perfiles";
import AsignacionPerfiles from "./components/Administracion/AsignacionPerfiles";
import TipoTribunal from "./components/Administracion/TipoTribunal";
import Estados from "./components/Administracion/Estados";
import ContactoClase from "./components/Administracion/ContactoClase";
import ConceptoDeuda from "./components/Administracion/ConceptoDeuda";
import AgregarSucursal from "./components/Administracion/AgregarSucursal";
import Reporte from "./components/Reportes/Reporte";
import Autofin from "./components/Reportes/Autofin";
import Quicksight from "./components/Reportes/Quicksight";
import SubmenuReportes from "./components/Reportes/SubmenuReportes";
import ReporteEnDesarrollo from "./components/Reportes/ReporteEnDesarrollo";
import ReporteVista from "./components/Reportes/ReporteVista";
import CargaMasiva from "./components/Operaciones/CargaMasiva";
import ResultadosCarga from "./components/Operaciones/ResultadosCarga";
import DireccionModulo from "./components/Administracion/DireccionModulo";
import Direccion from "./components/Administracion/Direccion";
import TribunalRol from "./components/Administracion/TribunalRol";
import { AuthProvider } from "./context/AuthContext";
import ConceptoGasto from "./components/Administracion/ConceptoGasto";
import ResultadoGestiones from "./components/Administracion/ResultadoGestiones";
import TipoGestiones from "./components/Administracion/TipoGestiones";
import TraspasoDeudas from "./components/TraspasoDeudas";
import Unidades from "./components/Administracion/Unidades";
import Clientes from "./components/Administracion/Clientes";
import Carteras from "./components/Administracion/Carteras";

// Tema visual - se importa al final para sobreescribir estilos previos
import "./styles/theme.css";

// Capturar callbacks de auth (MSAL y SAML) antes que HashRouter monte y
// corrompa el hash. HashRouter inserta un "/" después del "#" si el hash no
// empieza con "/", lo cual rompe el parseo tanto en MSAL como en SAML.
// Cada callback se guarda en su propio global; App.js los consume y limpia.
window.__msalCallbackHash__ = null;
window.__samlCallbackHash__ = null;
(function detectAuthCallback() {
  let hash = window.location.hash || "";
  if (/^#\/(code|access_token|id_token|token|error)=/.test(hash)) {
    hash = "#" + hash.substring(2);
  }
  if (/^#(code|access_token|id_token)=/.test(hash)) {
    window.__msalCallbackHash__ = hash;
    window.history.replaceState(
      null,
      "",
      window.location.pathname + window.location.search
    );
    return;
  }
  if (/^#(token|error)=/.test(hash)) {
    window.__samlCallbackHash__ = hash;
    window.history.replaceState(
      null,
      "",
      window.location.pathname + window.location.search
    );
  }
})();

ReactDOM.render(
  <HashRouter>
    <Switch>
      <AuthProvider>
        <Route exact path="/" component={App} />
        <Route exact path="/AgregarSucursal" component={AgregarSucursal} />
        <Route exact path="/ResultadosCarga" component={ResultadosCarga} />
        <Route
          exact
          path="/AsignacionPerfiles"
          component={AsignacionPerfiles}
        />
        <Route exact path="/Direccion" component={Direccion} />
        <Route exact path="/GeoAdmin" component={DireccionModulo} />
        <Route exact path="/TipoDireccion" component={DireccionType} />
        <Route exact path="/DireccionUnidad" component={DireccionUnidad} />
        <Route exact path="/Estados" component={Estados} />
        <Route exact path="/ConceptoDeuda" component={ConceptoDeuda} />
        <Route exact path="/TipoTribunal" component={TipoTribunal} />
        <Route exact path="/Separacion" component={Separacion} />
        <Route exact path="/Administracion" component={Administracion} />
        <Route exact path="/Operaciones" component={Operaciones} />
        <Route
          exact
          path="/AdministracionCausas/:id"
          component={AdministracionCausas}
        />
        <Route exact path="/BusquedaCausas" component={BusquedaCausas} />
        <Route exact path="/TraspasoDeudas" component={TraspasoDeudas} />
        <Route exact path="/Activo" component={Activo} />
        <Route exact path="/ContactoTipo" component={Contacto} />
        <Route exact path="/ContactoClase" component={ContactoClase} />
        <Route exact path="/Etapa" component={Etapa} />
        <Route exact path="/OrigenDatos" component={OrigenDatos} />
        <Route exact path="/Pais" component={Pais} />
        <Route exact path="/Usuarios" component={Usuarios} />
        <Route exact path="/Relaciones" component={Relaciones} />
        <Route exact path="/PersonaEmpresa" component={PersonaEmpresa} />
        <Route exact path="/TipoProceso" component={TipoProceso} />
        <Route exact path="/Titulos" component={Titulos} />
        <Route exact path="/Tribunal" component={Tribunal} />
        <Route exact path="/Moneda" component={Moneda} />
        <Route exact path="/Perfiles" component={Perfiles} />
        <Route exact path="/Reporte" component={Reporte} />
        <Route exact path="/Kpi" component={Quicksight} />
        <Route
          exact
          path="/Reporte/Autofin"
          render={(p) => <SubmenuReportes {...p} cliente="Autofin" />}
        />
        <Route
          exact
          path="/Reporte/Autofin/Asignacion"
          render={() => (
            <ReporteVista
              titulo="Reporte Cambio Etapa Autofin"
              viewName="v_carga_gestiones_autofin"
              endpointPath="reports/carga_gestiones_autofin"
              mandante="Autofin"
              filenamePrefix="Carga masiva de gestiones y cambio de etapa"
              dateFilter={true}
            />
          )}
        />
        <Route
          exact
          path="/Reporte/Autofin/Costas"
          render={() => (
            <ReporteVista
              titulo="Reporte Costas Autofin"
              viewName="v_costas_yag"
              endpointPath="reports/costas_yag"
              mandante="Autofin"
              filenamePrefix="costas_autofin"
            />
          )}
        />
        <Route
          exact
          path="/Reporte/Autofin/Comentario"
          render={() => (
            <ReporteVista
              titulo="Reporte Comentario Autofin"
              viewName="v_comentarios_autofin"
              endpointPath="reports/comentarios_autofin"
              mandante="Autofin"
              filenamePrefix="comentarios_autofin"
              dateFilter={true}
            />
          )}
        />
        <Route
          exact
          path="/Reporte/Autofin/CargaGestiones"
          component={Autofin}
        />
        <Route
          exact
          path="/Reporte/Global"
          render={(p) => <SubmenuReportes {...p} cliente="Global" />}
        />
        <Route
          exact
          path="/Reporte/Global/Asignacion"
          render={() => (
            <ReporteVista
              titulo="Reporte Cambio Etapa Global"
              viewName="v_carga_gestiones_autofin"
              endpointPath="reports/carga_gestiones_autofin"
              mandante="Global"
              filenamePrefix="Carga masiva de gestiones y cambio de etapa"
              dateFilter={true}
            />
          )}
        />
        <Route
          exact
          path="/Reporte/Global/Costas"
          render={() => (
            <ReporteVista
              titulo="Reporte Costas Global"
              viewName="v_costas_yag"
              endpointPath="reports/costas_yag"
              mandante="Global"
              filenamePrefix="costas_global"
            />
          )}
        />
        <Route
          exact
          path="/Reporte/Global/Comentario"
          render={() => (
            <ReporteVista
              titulo="Reporte Comentario Global"
              viewName="v_comentarios_autofin"
              endpointPath="reports/comentarios_autofin"
              mandante="Global"
              filenamePrefix="comentarios_global"
              dateFilter={true}
            />
          )}
        />
        <Route exact path="/CargaMasiva" component={CargaMasiva} />
        <Route exact path="/RolTribunal" component={TribunalRol} />
        <Route exact path="/ConceptoGasto" component={ConceptoGasto} />
        <Route
          exact
          path="/ResultadoGestiones"
          component={ResultadoGestiones}
        />
        <Route exact path="/TipoGestiones" component={TipoGestiones} />
        <Route exact path="/Unidades" component={Unidades} />
        <Route exact path="/Cliente" component={Clientes} />
        <Route exact path="/Cartera" component={Carteras} />
      </AuthProvider>
    </Switch>
  </HashRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
